export enum GameTypes {
    RIGHT_NOW = 1,
    ONE_HOUR = 2,
    THREE_HOURS = 3,
    //DAY_MARATHON = 4,
    FULL_DAY_MARATHON = 5,
}export enum GameTypes {
    RIGHT_NOW = 1,
    ONE_HOUR = 2,
    THREE_HOURS = 3,
    //DAY_MARATHON = 4,
    FULL_DAY_MARATHON = 5,
}